/* Auto-généré : mapping templateId → template ville */
import boulogne_billancourt from "./boulogne-billancourt";
import neuilly_sur_seine from "./neuilly-sur-seine";
import nanterre from "./nanterre";
import montrouge from "./montrouge";
import sevres from "./sevres";
import levallois_perret from "./levallois-perret";
import clichy from "./clichy";
import courbevoie from "./courbevoie";
import la_garenne_colombes from "./la-garenne-colombes";
import colombes from "./colombes";
import gennevilliers from "./gennevilliers";
import villeneuve_la_garenne from "./villeneuve-la-garenne";
import antony from "./antony";
import asnieres_sur_seine from "./asnieres-sur-seine";
import bagneux from "./bagneux";
import bois_colombes from "./bois-colombes";
import bourg_la_reine from "./bourg-la-reine";
import chatenay_malabry from "./chatenay-malabry";
import puteaux from "./puteaux";
import rueil_malmaison from "./rueil-malmaison";
import suresnes from "./suresnes";
import garches from "./garches";
import saint_cloud from "./saint-cloud";
import vaucresson from "./vaucresson";
import malakoff from "./malakoff";
import chatillon from "./chatillon";
import clamart from "./clamart";
import fontenay_aux_roses from "./fontenay-aux-roses";
import le_plessis_robinson from "./le-plessis-robinson";
import sceaux from "./sceaux";
import meudon from "./meudon";
import chaville from "./chaville";
import ville_davray from "./ville-davray";
import issy_les_moulineaux from "./issy-les-moulineaux";
import marnes_la_coquette from "./marnes-la-coquette";
import vanves from "./vanves";

export const CITY_TEMPLATES = {
  "boulogne-billancourt": boulogne_billancourt,
  "neuilly-sur-seine": neuilly_sur_seine,
  "nanterre": nanterre,
  "montrouge": montrouge,
  "sevres": sevres,
  "levallois-perret": levallois_perret,
  "clichy": clichy,
  "courbevoie": courbevoie,
  "la-garenne-colombes": la_garenne_colombes,
  "colombes": colombes,
  "gennevilliers": gennevilliers,
  "villeneuve-la-garenne": villeneuve_la_garenne,
  "antony": antony,
  "asnieres-sur-seine": asnieres_sur_seine,
  "bagneux": bagneux,
  "bois-colombes": bois_colombes,
  "bourg-la-reine": bourg_la_reine,
  "chatenay-malabry": chatenay_malabry,
  "puteaux": puteaux,
  "rueil-malmaison": rueil_malmaison,
  "suresnes": suresnes,
  "garches": garches,
  "saint-cloud": saint_cloud,
  "vaucresson": vaucresson,
  "malakoff": malakoff,
  "chatillon": chatillon,
  "clamart": clamart,
  "fontenay-aux-roses": fontenay_aux_roses,
  "le-plessis-robinson": le_plessis_robinson,
  "sceaux": sceaux,
  "meudon": meudon,
  "chaville": chaville,
  "ville-davray": ville_davray,
  "issy-les-moulineaux": issy_les_moulineaux,
  "marnes-la-coquette": marnes_la_coquette,
  "vanves": vanves,
};

export const getCityTemplate = (templateId) => CITY_TEMPLATES[templateId] || null;
